import 'iframe-resizer/js/iframeResizer.contentWindow'; // if embedded in an iframe (squarespace), this adds auto resizing. a separate script is needed to make it work with the parent page

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './components/AppContainer.jsx'
import axios from './api/axiosConfig'  // runs axios setup

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
